import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Router, ActivatedRoute } from '@angular/router';
import {environment} from '../../environments/environment'
@Injectable()
export class AuthService {
  private returnUrl;
  public currentUser;
  public currentName;
  public displayProfileImage;
  public token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6Im5hcmV0QGdtYWlsLmNvbSIsImZ1bGxOYW1lIjoibmFyZXQiLCJpZCI6OCwiaWF0IjoxNTMwNjAwMjcxfQ.xpDbSKx8PqbPJt98AEPy9tk2kYyE7oYaRXf_NZys4nM';
  constructor(private http: HttpClient, public router: Router, private route: ActivatedRoute) {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'];
    console.log(this.returnUrl);
  }
  login(username: string, password: string) {
   return this.http.post(environment.backend + '/users/login', {
      user: {
        username: username,
        password: password
      }
    })

  // if (username=='admin'&&password=='admin') {
  //   localStorage.setItem('currentUser', JSON.stringify({ token: this.token }));
  //   // this.currentUser = atob(this.token.split('.')[1]); // password
  //   console.log('loged in');
  //   this.router.navigateByUrl('/');
  // }else{
  //   console.log('error');
  // }
  
    // return this.http.post<any>('http://127.0.0.1:3000/helpdesk/api/singin', { username: username, password: password })
    //         .pipe(map((res: any) => {
    //           console.log('login success');
    //             // login successful if there's a jwt token in the response
    //             if (res.token) {
    //                 // store username and jwt token in local storage to keep user logged in between page refreshes
    //                 localStorage.setItem('currentUser', JSON.stringify({ username, token: res.token }));
    //                 console.log(res.token);
    //             }
    //         }));
  }

  logout() {
    localStorage.removeItem('currentUser');
  }

  getUser() {
    return this.currentUser;
  }
}



// WEBPACK FOOTER //
// /app/src/app/services/auth.service.ts